var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimezoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3H8.99998C7.04998 8.84 7.04998 15.16 8.99998 21H7.99998",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15.97 5.92 16.46 8.96 16.46 12",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16V15C5.92 15.97 8.96 16.46 12 16.46",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.0001C8.84 7.0501 15.16 7.0501 21 9.0001",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 19.0002C23.1667 21.3002 21.3 23.1668 19 23.1668C16.7 23.1668 14.8334 21.3002 14.8334 19.0002C14.8334 16.7002 16.7 14.8335 19 14.8335C21.3 14.8335 23.1667 16.7002 23.1667 19.0002Z",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5458 20.3252L19.2542 19.5544C19.0292 19.4211 18.8458 19.1002 18.8458 18.8377V17.1294",
    stroke: "#575A74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezoneIcon);
export default __webpack_public_path__ + "static/media/timezone-icon.ff11adce728844633f4d5abfcfd539f1.svg";
export { ForwardRef as ReactComponent };